// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ou-9";
export var arrowButtonContainer = "_ou-5";
export var arrowButtonIcon = "_ou-6";
export var carouselArrowButton = "_ou-2";
export var carouselElementContainer = "_ou-1";
export var currentSlide = "_ou-8";
export var left = "_ou-3";
export var otherSlide = "_ou-a";
export var productCarouselContainer = "_ou-0";
export var right = "_ou-4";
export var sliderOverflow = "_ou-7";